import type { Tracker } from 'usage-tracker-core';
import { CommandIds } from '../api/contentAssistanceApi';

export type UsageTracker = Tracker;

const NAMESPACE = 'content-assistance-lib';

let _usageTracker: UsageTracker | null = null;

export const getUsageTracker = (
  usageTracker: UsageTracker,
  usageDescription: string
) => {
  if (_usageTracker) {
    return _usageTracker;
  }

  _usageTracker = usageTracker.clone({
    properties: {
      namespace: NAMESPACE,
      usageDescription,
    },
    preserveTrackerProperties: false,
  });

  return _usageTracker;
};

export const getCurrentPrompt = (commandId: CommandIds, parameters: any) => {
  const currentPrompt = `commandId: ${commandId} - parameters: ${JSON.stringify(
    parameters
  )}`;
  return currentPrompt;
};
